import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Form, InputField, FormError } from '../form';
import { FormGroup, Button } from 'reactstrap';

import { Session } from '../../api'

import { Link } from 'react-router-dom';

const mapStateToProps = state => ({ ...state.login });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};


class LoginForm extends Component {
  
  render () {
    const { onSuccess, onFail } = this.props
    return (
      <Form
        onSubmit={Session.create}
        onSuccess={onSuccess}
        onFail={onFail}
        validate={values => {
          const errors = {};
          return errors;
        }}
        render={({ submitError, handleSubmit, reset, submitting, pristine, values }) => (
        
          <form onSubmit={handleSubmit} noValidate={true}>
            {submitError && <FormError>{submitError}</FormError>}
          
            <FormGroup>
              <InputField meta={{submitting}} name="email" type="email" placeholder="Email" />
            </FormGroup>
          
            <FormGroup>
              <InputField meta={{submitting}} name="password" type="password" placeholder="Password" />
            </FormGroup>
            
            <FormGroup className="small">
              <div className="text-right">
                <Link to="/reset">Forgot your password?</Link>
              </div>
            </FormGroup>
            
            <FormGroup>
              <Button
                className="upcase"
                color="primary"
                type="submit"
                block
                disabled={submitting}>
                Sign in
              </Button>
            </FormGroup>
            
            {false && <div className="small text-center">
              By signing in you agree that we store your session in cookies (more in <Link to="https://shorby.com/privacy">privacy policy</Link>)
            </div>}
            
            {false && <pre>JSON.stringify(values, 0, 2)</pre>}
          </form>
        )}
      />
    )
  };
}

export default connect(mapStateToProps, matchDispatchToProps)(LoginForm);


// WEBPACK FOOTER //
// ./src/components/auth/LoginForm.js